import React from 'react'

export interface HistoryLocation {
  replace: (path: string | Record<string, string>) => void
  location: Location
}

export interface Location {
  pathname: string
  search: string
}

const context = React.createContext(
  {} as {
    history: HistoryLocation
    location: Location
  },
)

export const useHistory = () => {
  const { history } = React.useContext(context)
  return history
}

export const useLocation = () => {
  const { location } = React.useContext(context)
  return location
}

export default context
